// extracted by mini-css-extract-plugin
export var blue = "TicketsCardPrimo-module--blue--zITrF";
export var details = "TicketsCardPrimo-module--details--rVfSn";
export var detailsOne = "TicketsCardPrimo-module--detailsOne--luKlh";
export var gray = "TicketsCardPrimo-module--gray--r91hE";
export var green = "TicketsCardPrimo-module--green--bm6AI";
export var heading = "TicketsCardPrimo-module--heading--8IUGh";
export var orange = "TicketsCardPrimo-module--orange--yjfM7";
export var price = "TicketsCardPrimo-module--price--sMo82";
export var root = "TicketsCardPrimo-module--root--kkkgA";
export var subtitle = "TicketsCardPrimo-module--subtitle--sGaaF";
export var title = "TicketsCardPrimo-module--title--8wLgb";